import React, { forwardRef } from "react";
import Blog from ".";
import { IBlogProps } from "./";

const RelatedArticle = forwardRef((props: IBlogProps, ref: any) => {
    const {
        tags,
        title,
        href,
        src,
        alt,
        timestamp,
        cmsId,
        editorClassObj,
        dateType,
    } = props;

    return (
        <Blog
            cmsId={cmsId}
            editorClassObj={editorClassObj}
            headerAs="h5"
            title={title || ''}
            src={src || ''}
            alt={alt || ''}
            tags={tags || ''}
            timestamp={timestamp || 0}
            href={href}
            dateType={dateType}
            isMainArticle={false}
        />
    );
});

export default RelatedArticle;
